import { IRootState } from '../reducer'
import { prefix } from './actions'

export const agenda = (state: IRootState) => state[prefix].agenda

export const calendarRange = (state: IRootState) => state[prefix].calendarRange

export const myWork = (state: IRootState) => state[prefix].myWork

export const myClientsHealth = (state: IRootState) => state[prefix].myClientsHealth

export const myDiligence = (state: IRootState) => state[prefix].myDiligence

export const dashboardProspects = (state: IRootState) => state[prefix].dashboardProspects

export const dealCleanupSuggestions = (state: IRootState) => state[prefix].dealCleanupSuggestions

export const briefing = (state: IRootState) => state[prefix].briefing

export const meetingBriefs = (state: IRootState) => state[prefix].meetingBriefs
